import StudentInfoRequestResponseModel from "src/models/StudentInfoRequestResponseModel";
import { InfoRequestType, studentInfoRequests } from "types/code-generator";
import InputError from "../inputs/InputError";
import {
  InputRadioButton,
  InputRadioButtons,
} from "../inputs/InputRadioButton";
import InputSelect, { InputOption } from "../inputs/InputSelect";
import { InputText } from "../inputs/InputText";
import SlideDown from "../layout/SlideDown";

interface Props {
  infoRequest: studentInfoRequests["studentInfoRequests"][0];
  existingInfoRequestResponse?: StudentInfoRequestResponseModel;
  hasAdditional?: boolean;
  updateInfoRequestResponse: (
    infoRequestResponse: StudentInfoRequestResponseModel
  ) => void;
  error?: string;
}

export function ParticipantInfoRequest(props: Props) {
  return (
    <div className="mb-4">
      <div className="mb-2">
        {props.infoRequest.required && <span className="text-error">*</span>}{" "}
        <strong>{props.infoRequest.description}</strong>
      </div>

      {(props.infoRequest.type === InfoRequestType.Text ||
        !props.infoRequest.type) && (
        <InputText
          value={props.existingInfoRequestResponse?.description || ""}
          name="description"
          onChange={(description) =>
            props.updateInfoRequestResponse({
              studentInfoRequest: props.infoRequest,
              description,
              additionalResponse: "",
            })
          }
          placeholder="Response"
        />
      )}

      {props.infoRequest.type === InfoRequestType.Predefined && (
        <InputSelect
          placeholder="Select option"
          value={props.existingInfoRequestResponse?.description || ""}
          onChange={(description) =>
            props.updateInfoRequestResponse({
              studentInfoRequest: props.infoRequest,
              description,
              additionalResponse: "",
            })
          }
        >
          {props.infoRequest.answers.map((a, i) => {
            return (
              <InputOption value={a} key={i}>
                {a}
              </InputOption>
            );
          })}
        </InputSelect>
      )}

      {props.infoRequest.type === InfoRequestType.YesNo && (
        <>
          <InputRadioButtons
            value={props.existingInfoRequestResponse?.description || ""}
            onChange={(value) =>
              props.updateInfoRequestResponse({
                studentInfoRequest: props.infoRequest,
                description: value,
                additionalResponse: "",
              })
            }
          >
            <InputRadioButton value="Yes">Yes</InputRadioButton>
            <InputRadioButton value="No">No</InputRadioButton>
          </InputRadioButtons>
        </>
      )}

      <SlideDown>
        {props.hasAdditional && (
          <div className="mb-4 pt-2">
            <div className="mb-2 font-bold">
              {props.infoRequest.required && (
                <span className="text-error">*</span>
              )}{" "}
              {props.existingInfoRequestResponse?.description === "Yes"
                ? props.infoRequest.yesQuestion
                : props.infoRequest.noQuestion}
            </div>

            <InputText
              value={
                props.existingInfoRequestResponse?.additionalResponse || ""
              }
              name="additionalResponse"
              onChange={(additionalResponse) =>
                props.updateInfoRequestResponse({
                  studentInfoRequest: props.infoRequest,
                  description: props.existingInfoRequestResponse?.description,
                  additionalResponse,
                })
              }
              placeholder="Response"
            />
          </div>
        )}
      </SlideDown>

      <InputError error={props.error} className="pt-2" />
    </div>
  );
}
